const actions = {
  FETCH_ALL_ASSETS: 'assetsManagement/FETCH_ALL_ASSETS',
  SET_STATE: 'assetsManagement/SET_STATE',
  UPLOAD_ASSETS: 'assetsManagement/UPLOAD_ASSETS',
  REMOVE_ASSETS: 'assetsManagement/REMOVE_ASSETS',
}

export default actions
